var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIreland(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_161_196)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.27778 3.47222C2.54107 3.47222 1.83453 3.76488 1.31359 4.28581C0.792658 4.80675 0.5 5.51329 0.5 6.25L0.5 18.75C0.5 19.4867 0.792658 20.1932 1.31359 20.7142C1.83453 21.2351 2.54107 21.5278 3.27778 21.5278H8.83333V3.47222H3.27778Z",
    fill: "#169B62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.83334 3.47222H17.1667V21.5278H8.83334V3.47222Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7222 3.47222H17.1667V21.5278H22.7222C23.4589 21.5278 24.1655 21.2351 24.6864 20.7142C25.2073 20.1932 25.5 19.4867 25.5 18.75V6.25C25.5 5.51329 25.2073 4.80675 24.6864 4.28581C24.1655 3.76488 23.4589 3.47222 22.7222 3.47222Z",
    fill: "#FF883E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_161_196"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIreland);
export default __webpack_public_path__ + "static/media/Ireland.e86df8badcf6b22fef5bbc9eec16a193.svg";
export { ForwardRef as ReactComponent };